module.exports = __webpack_public_path__ + "img/yuexiugongyuan.b75fa01d.jpg";